'use strict'

const $ = window.$ = window.jQuery = require('jquery')
require('magicsearch/dist/js/jquery.magicsearch')

export default function () {
  let $searchInput = $('input[name=tanals_contacts_search][type=text]')
  let $resultInput = $('input[name=tanals_contacts]')
  let dataSource = $searchInput.attr('data-source')
  let noResult = $searchInput.attr('data-no_result') || 'Aucun résultat'

  let update = function ($input) {
    let value = ($input.attr('data-id')) ? JSON.stringify($input.attr('data-id').split(',')) : '[]'

    $resultInput.attr('value', value)

    return $searchInput
  }

  update($searchInput).magicsearch({
    dataSource: dataSource,
    type: 'ajax',
    fields: ['first_name', 'last_name'],
    id: 'id',
    format: '%first_name% %last_name%',
    multiple: true,
    multiField: 'first_name% %last_name',
    noResult: noResult,
    multiStyle: {
      space: 0,
      width: 'auto'
    },
    success: update,
    afterDelete: update
  })
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/users/contacts.js